export default "__VITE_ASSET__DLwZvNtG__"